import PropTypes from 'prop-types'

import React from 'react'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'

import './PopupConfirm.scss'

function PopupConfirm(props) {
  const {
    show,
    onClose,
    titleHeader,
    iconUrl,
    title,
    children,
    backdrop,
    useWhiteBackground,
    size,
    align,
    cancelLabel,
    okLabel,
    onOkClick,
    modalClass,
    renderActions,
  } = props

  const popupClass = `popup modal-confirm ${modalClass} ${align === 'center' && 'text-center'} ${
    useWhiteBackground && 'modal-dialog-white'
  } ${!!iconUrl && 'modal-dialog-with-icon'}`

  return (
    <Modal
      centered
      scrollable
      isOpen={show}
      toggle={onClose}
      backdrop={backdrop}
      keyboard={false}
      size={size}
      className={popupClass}
    >
      {titleHeader && <ModalHeader>{titleHeader}</ModalHeader>}

      {iconUrl && (
        <div className="modal-icon">
          <img src={iconUrl} alt={title} />
        </div>
      )}

      <ModalBody>
        {children}
        {renderActions && (
          <div className="popup-confirm__action">
            <Button color="dark" onClick={onClose} className="popup-confirm__cancel" type="button">
              {cancelLabel}
            </Button>
            <Button color="primary" onClick={onOkClick} className="popup-confirm__confirm">
              {okLabel}
            </Button>
          </div>
        )}
      </ModalBody>
    </Modal>
  )
}

PopupConfirm.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,

  iconUrl: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.any,

  modalClass: PropTypes.string,
  useWhiteBackground: PropTypes.bool,
  backdrop: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  align: PropTypes.oneOf(['left', 'center']),

  cancelLabel: PropTypes.string,
  okLabel: PropTypes.string,
  onOkClick: PropTypes.func,
  renderActions: PropTypes.bool,
}

PopupConfirm.defaultProps = {
  show: false,
  onClose: PropTypes.func,

  iconUrl: '',
  title: '',
  children: null,

  useWhiteBackground: false,
  backdrop: true,
  size: 'md',
  align: 'left',

  cancelLabel: 'Cancel',
  okLabel: 'Ok',
  onOkClick: null,
  renderActions: true,
}

export default PopupConfirm
